import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  access(parameters={}) {
    return core.call({
      url: '/api/v1/logging/access',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  }
}

